import Service from "../../../Services/index";
import moment from "moment"

const ScanEmployee = {
    namespaced: true,
    state: {
        scan_employee:[],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        form:{
            id: "",
            employee_no : "",
            employee: "",
            time_scan: ""
        },

        form_PDF:{
            start_date: "",
            end_date : "",
        },
        search:{
            employee: "",
            employee_id : "",
            date : [],
            department : null,
        },
        form_import_ot :{
            id : null,
            employee : null,
            date : '',
            hour : '',
        },
    },
    mutations: {
        GET_SCAN_EMPLOYEE: (state, res) => {
            state.scan_employee = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.total
            }
        },
        GET_SCAN_EMPLOYEE_BY_ID:(state,res)=>{
            state.form = res;
        },
        GET_OT_HOUR : (state,res)=>{
            state.form_import_ot = res;
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                id: "",
                employee_no : "",
                employee: "",
                time_scan: ""
            };

            state.form_PDF = {
                start_date: "",
                end_date : "",
            };

            state.form_import_ot = {
                id : null,
                employee : null,
                date : '',
                hour : '',
            }
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                employee: "",
                employee_id : "",
                date : ""
            }
        }
    },
    actions: {
        setScanEmployee({commit},page=1){
            return Service.ScanEmployee.getScanEmployee(page).then(response => {
                commit("GET_SCAN_EMPLOYEE", response);
            });
        },
        createScanEmployee({commit},data){
            return Service.ScanEmployee.createScanEmployee(data).then(()=>{
                console.log('create');
            });
        },
        updateScanEmployee({commit},{id,data}){
            return Service.ScanEmployee.updateScanEmployee(id,data);
        },
        showScanEmployeeById({commit},id){
            return Service.ScanEmployee.showScanEmployee(id).then(res=>{
                commit('GET_SCAN_EMPLOYEE_BY_ID',res);
            });
        },
        deleteScanEmployee({commit},id){
            return Service.ScanEmployee.deleteScanEmployee(id);
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        search({commit},data){
            return Service.ScanEmployee.searchScanEmployee(data).then(res=>{
                commit("GET_SCAN_EMPLOYEE", res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        //import ot hour
        getImportHour({commit},data){
            return Service.ScanEmployee.getImportOTHour(data);
        },
        showImportHour({commit},id){
            return Service.ScanEmployee.showImportOTHour(id).then(res=>{
                commit('GET_OT_HOUR',res);
            });
        },
        updateImportHour({commit},{id,data}){
            return Service.ScanEmployee.updateImportOTHour(id,data);
        },
        createImportHour({commit},data){
            return Service.ScanEmployee.createImportOTHour(data);
        },
        deleteImportHour({commit},id){
            return Service.ScanEmployee.deleteImportOTHour(id);
        },
        printScanEmployeePDF({commit},data){
            console.log(data);
            return Service.ScanEmployee.printScanEmployeePDF(data);
        }
    }
};
export default ScanEmployee;
